// extracted by mini-css-extract-plugin
module.exports = {"margin-group-label":"zJZMFMao_EdfOWPm5JKun","margin-group-desc":"_2jjv6CUFShstb8N68Z7HxC"};